import * as React from "react";

const ErrorBox: React.FC = ({ children }) => {
  return <div style={{ border: "1px solid red" }}>{children}</div>;
};

export default ErrorBox;
